export const isRedirectedFromWicketLogin = (currentUrl: string): boolean =>
  currentUrl.includes(`?code=`) || currentUrl.includes(`&code=`);

export const isRedirectedFromWicketLogout = (currentUrl: string): boolean =>
  currentUrl.includes(`?logout=true`) || currentUrl.includes(`&logout=true`);
